module.exports = __webpack_public_path__ + "img/dea-formazione-ico-ambienti-di-apprendimento.66306b24.svg";